import script from "./ant-set.vue?vue&type=script&setup=true&lang=js"
export * from "./ant-set.vue?vue&type=script&setup=true&lang=js"

import "./ant-set.vue?vue&type=style&index=0&id=3670860c&lang=scss"

const __exports__ = script;

export default __exports__